var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconMicrosoftg = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 21 21",
  width: 21
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f25022",
  d: "M1 1h9v9H1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00a4ef",
  d: "M1 11h9v9H1z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#7fba00",
  d: "M11 1h9v9h-9z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb900",
  d: "M11 11h9v9h-9z"
})));
export default SvgIconMicrosoftg;